var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"content":_vm.value,"disabled":_vm.tooltipShow,"placement":"top-start"}},[_c('span',{staticStyle:{"white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis","width":"200px"}},[_c('span',{ref:"content",on:{"mouseover":_vm.isShowTooltip}},[_vm._v(_vm._s(_vm.value))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }